import { useQuery } from "@tanstack/react-query";
import { ArrowUpRight, BellRing, CalendarDays, MapPin, Sparkles } from "lucide-react";
import { useNavigate } from "react-router-dom";
import HomeHero from "../components/HomeHero";
import PropertyCard from "../components/PropertyCard";
import SiteFooter from "../components/SiteFooter";
import { getProperties } from "../lib/api";

export default function HomePage({ favorites, onFavorite }) {
  const navigate = useNavigate();
  const { data: properties = [], isLoading } = useQuery({ queryKey: ["featured-properties"], queryFn: () => getProperties() });

  return (
    <main data-testid="home-page">
      <HomeHero />

      <section className="section container" id="selection">
        <div className="section-heading">
          <div>
            <p className="eyebrow">Sélection du moment</p>
            <h2>Des lieux qui racontent<br />déjà une histoire.</h2>
          </div>
          <button className="text-action" onClick={() => navigate("/biens")} data-testid="all-properties-button">Voir tous les biens <ArrowUpRight size={18} /></button>
        </div>
        <div className="property-grid home-property-grid" data-testid="featured-properties-grid">
          {isLoading ? <p data-testid="properties-loading">Les biens arrivent...</p> : properties.slice(0, 3).map((property) => (
            <PropertyCard key={property.id} property={property} onFavorite={onFavorite} isFavorite={favorites.some((item) => item.id === property.id)} />
          ))}
        </div>
      </section>

      <section className="editorial-band">
        <div className="container seller-band">
          <div className="seller-copy">
            <p className="eyebrow coral-text">Vous vendez ?</p>
            <h2>Faire de votre bien<br />une évidence.</h2>
            <p>Estimation juste, stratégie claire, mise en scène soignée. Votre prochain chapitre commence ici.</p>
            <button className="secondary-button" onClick={() => navigate("/estimation")} data-testid="seller-estimate-button">Estimer mon bien <ArrowUpRight size={18} /></button>
          </div>
          <div className="seller-stat-grid" data-testid="seller-stats">
            <div><strong>48h</strong><span>pour recevoir votre première estimation</span></div>
            <div><strong>1</strong><span>expert local à vos côtés</span></div>
            <div><strong>100%</strong><span>sur mesure, du projet à la signature</span></div>
          </div>
        </div>
      </section>

      <section className="section container services-section">
        <div className="section-heading compact-heading">
          <div><p className="eyebrow">Un parcours simple</p><h2>Vous êtes<br />entre de bonnes mains.</h2></div>
          <p className="section-intro">Une agence vive, locale et engagée — pour faire avancer vos projets avec sérénité.</p>
        </div>
        <div className="service-grid">
          <article data-testid="service-estimate-card"><Sparkles size={27} /><h3>Une estimation qui compte</h3><p>Une lecture précise du marché vauclusien et du potentiel unique de votre bien.</p><button onClick={() => navigate("/estimation")} data-testid="service-estimate-button">Estimer <ArrowUpRight size={17} /></button></article>
          <article data-testid="service-visit-card"><CalendarDays size={27} /><h3>Visiter à votre rythme</h3><p>Choisissez votre créneau en ligne, nos conseillers s'occupent de la suite.</p><button onClick={() => navigate("/biens")} data-testid="service-visit-button">Trouver un bien <ArrowUpRight size={17} /></button></article>
          <article data-testid="service-alert-card"><BellRing size={27} /><h3>Ne manquez rien</h3><p>Recevez les nouvelles adresses qui correspondent vraiment à votre projet.</p><button onClick={() => navigate("/alertes")} data-testid="service-alert-button">Créer une alerte <ArrowUpRight size={17} /></button></article>
        </div>
      </section>

      <section className="local-seo-section container" data-testid="local-seo-section">
        <div><p className="eyebrow coral-text">Immobilier local</p><h2>Votre agence immobilière<br />à L’Isle-sur-la-Sorgue, Avignon et dans le Vaucluse.</h2></div>
        <div><p>Vous achetez, vendez ou préparez une estimation immobilière ? Pimp My Place vous accompagne avec une connaissance concrète de L’Isle-sur-la-Sorgue, Avignon et des adresses recherchées du Vaucluse.</p><div className="local-seo-links"><button onClick={() => navigate("/biens?city=L%27Isle-sur-la-Sorgue")} data-testid="local-isle-properties-button">Maisons à L’Isle-sur-la-Sorgue <ArrowUpRight size={16} /></button><button onClick={() => navigate("/estimation")} data-testid="local-estimate-button">Estimer mon bien dans le Vaucluse <ArrowUpRight size={16} /></button></div></div>
      </section>

      <section className="referral-section container" data-testid="referral-promotion-section">
        <div className="referral-visual" />
        <div className="referral-copy">
          <p className="eyebrow">Parrainage</p>
          <h2>Une bonne adresse<br />mérite d'être partagée.</h2>
          <p>Vous connaissez quelqu'un qui envisage de vendre dans le Vaucluse ? Présentez-nous. Si la vente se concrétise, vous recevez <strong>500 €</strong>.</p>
          <button className="primary-button" onClick={() => navigate("/parrainage")} data-testid="referral-cta-button">Je recommande un proche <ArrowUpRight size={18} /></button>
        </div>
      </section>

      <section className="location-strip" data-testid="coverage-area-section">
        <MapPin size={18} /><span>Avignon</span><span>Gordes</span><span>L'Isle-sur-la-Sorgue</span><span>Apt</span><span>Vaison-la-Romaine</span><span>Mont Ventoux</span>
      </section>
      <SiteFooter />
    </main>
  );
}